import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import InputAdornment from "@mui/material/InputAdornment";
import { CircularProgress } from "../../../CircularProgress/index.js";
import Preloader_style from "./Preloader.style.js";
const Preloader = ()=>{
    const $ = c(4);
    const { classes } = Preloader_style();
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            height: 0
        };
        t1 = /*#__PURE__*/ jsx(CircularProgress, {
            size: 18
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] !== classes.preloader) {
        t2 = /*#__PURE__*/ jsx(InputAdornment, {
            className: classes.preloader,
            position: "end",
            sx: t0,
            children: t1
        });
        $[2] = classes.preloader;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
export { Preloader };
